import type { MantineColorScheme } from "@mantine/core";

export const DEFAULT_COLORSCHEME: MantineColorScheme = "auto";

export const SYSTEM_COLORS = {
  error: "red",
  warning: "var(--mantine-color-orange-5)",
  success: "var(--mantine-color-green-7)",
  info: "var(--mantine-color-blue-5)",
  default: "var(--mantine-color-gray-6)",
  disabled: "var(--mantine-color-gray-5)",
  primary: "primary",
  secondary: "secondary",
  white: "white",
  // ENTITIES
  WORKSPACE: "var(--mantine-color-gray-6)",
  DEPLOYMENT: "var(--mantine-color-violet-6)",
  DEVICE: "var(--mantine-color-indigo-6)",
  PART: "var(--mantine-color-grape-6)",
  CASE: "var(--mantine-color-pink-6)",
  MAINTENANCE: "var(--mantine-color-cyan-6)",
  MAINTENANCE_STRATEGY: "var(--mantine-color-yellow-6)",
  MAINTENANCE_CALENDAR_EVENT: "var(--mantine-color-blue-filled)",
  TASK: "var(--mantine-color-teal-6)",
  CHECKLIST_TEMPLATE: "var(--mantine-color-lime-6)",
  USER: "var(--mantine-color-blue-6)",
  INVENTORY_ACTION_ADD: "var(--mantine-color-green-4)",
  INVENTORY_ACTION_REMOVE: "var(--mantine-color-red-4)",
  INVENTORY_ACTION_CHANGE: "var(--mantine-color-blue-4)",
  INVENTORY_ACTION_MOVE: "var(--mantine-color-orange-4)",
  INVENTORY_ACTION_ISOLATE: "var(--mantine-color-yellow-4)",
  INVENTORY_ACTION_ASSEMBLE: "var(--mantine-color-violet-4)",
  INVENTORY_ACTION_DISASSEMBLE: "var(--mantine-color-cyan-4)",
  ACADEMY: "var(--mantine-color-yellow-6)",
  INSIGHTS: "var(--mantine-color-violet-6)",
  FILTERS: "var(--mantine-color-secondary-9)",
  FILTERS_ACTIVE: "var(--mantine-color-secondary-3)",
};
